const hotels = [
  {
    id: 0,
    cover_name: "VIP-люкс отели",
    cover_image: "/set-premium-gold-crown-winner-luxury-success-sign-symbol-icon-cartoon-background-3d-illustration.jpg",
    cover_description: "Cover description",
    hotels: [
      {
        hotel_img: "/hotels VIP/BVLGARI Hotel Shanghai.jpg",
        name: "BVLGARI Hotel Shanghai",
        url:'https://www.bulgarihotels.com/en_US/shanghai',
        price:806
      },
      {
        hotel_img: "/hotels VIP/Amanyangyun Shanghai.jpg",
        name: "Amanyangyun Shanghai",
        url:'https://www.aman.com/resorts/amanyangyun',
        price:833
      },
      {
        hotel_img: "/hotels VIP/BVLGARI Hotel Beijing .jpg",
        name: "BVLGARI Hotel Beijing",
        url:'https://www.bulgarihotels.com/ru_RU/beijing',
        price:695
      },
      {
        hotel_img: "/hotels VIP/Aman Summer Palace Beijing.jpg",
        name: "Aman Summer Palace Beijing",
        url:'https://www.aman.com/resorts/aman-summer-palace',
        price:635
      },
      {
        hotel_img: "/hotels VIP/Mandarin Oriental Wangfujing.jpg",
        name: "Mandarin Oriental Wangfujing",
        url:'https://www.mandarinoriental.com/en/beijing/wangfujing/stay',
        price:636
      },
      {
        hotel_img: "/hotels VIP/InterContinental Beijing.jpg",
        name: "InterContinental Beijing Sanlitun",
        url:'https://www.ihg.com/intercontinental/hotels/ru/ru/beijing/peghe/hoteldetail',
        price:255
      },
      {
        hotel_img: "/hotels VIP/ROSEWOOD Beijing.jpg",
        name: "ROSEWOOD Beijing",
        url:'https://www.rosewoodhotels.com/en/beijing',
        price:338
      },
      {
        hotel_img: "/hotels VIP/The Peninsula Beijing .jpg",
        name: "The Peninsula Beijing",
        url:'https://www.peninsula.com/en/newsroom/beijing',
        price:361
      },
      {
        hotel_img: "/hotels VIP/The PuXuan Hotel and Spa.jpg",
        name: "The PuXuan Hotel and Spa",
        url:'https://thepuxuan.com/en/',
        price:328
      },
      {
        hotel_img: "/hotels VIP/Waldorf Astoria Beijing.jpg",
        name: "Waldorf Astoria Beijing",
        url:'https://www.hilton.com/en/hotels/bjswawa-waldorf-astoria-beijing/',
        price:348
      },
      {
        hotel_img: "/hotels VIP/PARK HYATT Beijing.jpg",
        name: "PARK HYATT Beijing",
        url:'https://www.hyatt.com/en-US/hotel/china/park-hyatt-beijing/beiph',
        price:278
      },
      {
        hotel_img: "/hotels VIP/NUO Resort Universal Studios.jpg",
        name: "NUO Resort Universal Studios",
        url:'https://www.universalbeijingresort.com/en/hotels/nuo-resort',
        price:259
      },
      {
        hotel_img: "/hotels VIP/Sunrise Kempinski Hotel Beijing.jpg",
        name: "Sunrise Kempinski Hotel Beijing",
        url:'https://www.kempinski.com/en/sunrise-kempinski-hotel-beijing/overview',
        price:261
      },
      {
        hotel_img: "/hotels VIP/Yanqi Lake by Kempinski .jpg",
        name: "Yanqi Lake by Kempinski ",
        url:'https://www.kempinski.com/en/yanqi-hotel-managed-by-kempinski/overview ',
        price:350
      },
      {
        hotel_img: "/hotels VIP/J Hotel Shanghai Tower.jpg",
        name: "J Hotel Shanghai Tower",
        url: "https://www.jhotel-shanghai.com/",
        price: 576,
      },
      {
        hotel_img: "/hotels VIP/Bellagio Shanghai.jpg",
        name: "Bellagio Shanghai",
        url: "http://bellagiohotelshanghai.com/",
        price: 293,
      },
      {
        hotel_img: "/hotels VIP/CAPELLA SHANGHAI.jpg",
        name: "CAPELLA SHANGHAI",
        url: "https://capellahotels.com/en/capella-shanghai",
        price: 485,
      },
      {
        hotel_img: "/hotels VIP/Fairmont Peace Hotel.jpg",
        name: "Fairmont Peace Hotel",
        url: "https://www.fairmont-ru.com/peace-hotel-shanghai/",
        price: 350,
      },
      {
        hotel_img: "/hotels VIP/Mandarin Oriental Pudong.jpg",
        name: "Mandarin Oriental Pudong",
        url: "https://www.mandarinoriental.com/en/shanghai/pudong/stay",
        price: 263,
      },
      {
        hotel_img: "/hotels VIP/Park Hyatt Shanghai.jpg",
        name: "Park Hyatt Shanghai",
        url: "https://www.hyatt.com/en-US/hotel/china/park-hyatt-shanghai/shaph",
        price: 361,
      },
      {
        hotel_img: "/hotels VIP/The Peninsula Shanghai.jpg",
        name: "The Peninsula Shanghai",
        url: "https://www.peninsula.com.cn/en/shanghai/special-offers",
        price: 400,
      },
      {
        hotel_img: "/hotels VIP/The Ritz-Carlton Pudong.jpg",
        name: "The Ritz-Carlton Pudong",
        url: "https://www.ritzcarlton.com/en/hotels/shasz-the-ritz-carlton-shanghai-pudong/overview/",
        price: 345,
      },
      {
        hotel_img: "/hotels VIP/Waldorf Astoria Shanghai on the Bund.jpg",
        name: "Waldorf Astoria Shanghai on the Bund",
        url: "https://www.hilton.com/en/hotels/shawawa-waldorf-astoria-shanghai-on-the-bund/",
        price: 319,
      },
      {
        hotel_img: "/hotels VIP/W Shanghai The Bund.jpg",
        name: "W Shanghai The Bund",
        url: "https://www.marriott.com/en-us/hotels/shawh-w-shanghai-the-bund/overview/",
        price: 289,
      },
      {
        hotel_img: "/hotels VIP/The Sukhothai Shanghai.jpg",
        name: "The Sukhothai Shanghai",
        url: "https://www.sukhothai.com/shanghai/en",
        price: 254,
      },
      {
        hotel_img: "/hotels VIP/The Shanghai EDITION.jpg",
        name: "The Shanghai EDITION",
        url: "https://www.editionhotels.com/shanghai/",
        price: 276,
      },
      {
        hotel_img: "/hotels VIP/Wanda Reign on the Bund.jpg",
        name: "Wanda Reign on the Bund",
        url: "https://www.wandahotels.com/en/hotel/wanda-reign-shanghai-booking-65-52",
        price: 269,
      },
      {
        hotel_img: "/hotels VIP/InterContinental Shanghai Wonderland.jpg",
        name: "InterContinental Shanghai Wonderland ",
        url: "https://www.ihg.com/intercontinental/hotels/us/en/shanghai/shghe/hoteldetail/rooms",
        price: 328,
      },
      {
        hotel_img: "/hotels VIP/The Temple House Chengdu.jpg",
        name: "The Temple House Chengdu",
        url: "https://www.thesetcollection.com/the-temple-house/",
        price: 308,
      },
      {
        hotel_img: "/hotels VIP/Six Senses Qing Cheng Mountain Chengdu.jpg",
        name: "Six Senses Qing Cheng Mountain Chengdu",
        url: "https://www.sixsenses.com/en/resorts/qing-cheng-mountain/",
        price: 327,
      },
      {
        hotel_img: "/hotels VIP/Diaoyutai Boutique Hotel Chengdu .jpg",
        name: "Diaoyutai Boutique Hotel Chengdu ",
        url: "http://en.diaoyutaichengdu.cn/",
        price: 301,
      },
      {
        hotel_img: "/hotels VIP/Rissai Valley, a Ritz-Carlton Reserve.jpg",
        name: "Rissai Valley, a Ritz-Carlton Reserve",
        url: "https://www.ritzcarlton.com/en/hotels/jzhrz-rissai-valley-a-ritz-carlton-reserve/overview/",
        price: 1166,
      },
      {
        hotel_img: "/hotels VIP/Four Seasons Hotel Hangzhou at West Lake.jpg",
        name: "Four Seasons Hotel Hangzhou at West Lake",
        url: "https://www.fourseasons.com/hangzhou/",
        price: 521,
      },
      {
        hotel_img: "/hotels VIP/Banyan Tree Hangzhou.jpg",
        name: "Banyan Tree Hangzhou",
        url: "https://www.banyantree.com/china/hangzhou",
        price: 357,
      },
      {
        hotel_img: "/hotels VIP/JiuTai Hotel Hangzhou.jpg",
        name: "JiuTai Hotel Hangzhou",
        url: "https://wwwadmin.zhongkehotels.com/portal/page/index/id/158.html",
        price: 259,
      },
      {
        hotel_img: "/hotels VIP/Park Hyatt Hangzhou.jpg",
        name: "Park Hyatt Hangzhou",
        url: "https://www.hyatt.com/en-US/hotel/china/park-hyatt-hangzhou/hanph",
        price: 158,
      },
      {
        hotel_img: "/hotels VIP/Park Hyatt Sanya Sunny Bay Resort.jpg",
        name: "Park Hyatt Sanya Sunny Bay Resort",
        url: "https://www.hyatt.com/en-US/hotel/china/park-hyatt-sanya/sanph",
        price: 276,
      },
      {
        hotel_img: "/hotels VIP/Rosewood Sanya.jpg",
        name: "Rosewood Sanya",
        url: "https://www.rosewoodhotels.com/en/sanya",
        price: 288,
      },
      {
        hotel_img: "/hotels VIP/The Sanya EDITION.jpg",
        name: "The Sanya EDITION",
        url: "https://www.editionhotels.com/sanya/",
        price: 261,
      },
      
   
   
   
   
      
   
    ],
  },
  {
    id: 1,
    cover_name: "Премиум-люкс отели",
    cover_image: "/golden-correct-tick-mark-sign-best-quality-assurance-with-golden-five-stars-guarantee-product-iso-service-concept-by-3d-render.jpg",
    cover_description: "Cover description",
    hotels: [
      {
        hotel_img: '/hotels premium/The Ritz-Carlton Beijing.jpg',
        name: 'The Ritz-Carlton',
        url: 'https://www.ritzcarlton.com/en/hotels/bjsrz-the-ritz-carlton-beijing/overview/',
        price: 215
      },
      {
        hotel_img: '/hotels premium/The St. Regis Beijing .jpg',
        name: 'The St. Regis Beijing ',
        url: 'https://www.marriott.com/en-us/hotels/bjsxr-the-st-regis-beijing/overview/',
        price: 174
      },
      {
        hotel_img: '/hotels premium/FOUR SEASONS HOTEL.jpg',
        name: 'FOUR SEASONS HOTEL',
        url: 'https://www.fourseasons.com/beijing/',
        price: 213
      },
      {
        hotel_img: '/hotels premium/Shangri-La China World.webp',
        name: 'Shangri-La China World',
        url: 'https://www.shangri-la.com/beijing/chinaworld/about/',
        price: 215
      },
      {
        hotel_img: '/hotels premium/Kerry Hotel.jpg',
        name: 'Kerry Hotel',
        url: 'https://www.beijingkerryresidence.com/',
        price: 174
      },
      {
        hotel_img: '/hotels premium/The Opposite House Beijing.jpg',
        name: 'The Opposite House Beijing',
        url: 'https://www.thesetcollection.com/the-opposite-house/',
        price: 248
      },
      {
        hotel_img: '/hotels premium/RENAISSANCE BEIJING WANGFUJING HOTEL.jpg',
        name: 'RENAISSANCE BEIJING WANGFUJING HOTEL',
        url: 'https://www.marriott.com/en-us/hotels/bjswf-renaissance-beijing-wangfujing-hotel/overview/',
        price: 195
      },
      {
        hotel_img: '/hotels premium/InterContinental Beijing Beichen.jpg',
        name: 'InterContinental Beijing Beichen',
        url: 'https://www.ihg.com/intercontinental/hotels/ru/ru/beijing/peghc/hoteldetail',
        price: 198
      },
      {
        hotel_img: '/hotels premium/Chao Sanlitun Beijing.jpg',
        name: 'Chao Sanlitun Beijing',
        url: 'http://ilovechao.com/show/hotel',
        price: 247
      },
      {
        hotel_img: '/hotels premium/Hotel Éclat Beijing.jpg',
        name: 'Hotel Éclat Beijing',
        url: 'https://www.eclathotels.com/beijing',
        price: 206
      },
      {
        hotel_img: '/hotels premium/JEN Hotel by Shangri-La.jpg',
        name: 'JEN Hotel by Shangri-La',
        url: 'https://www.shangri-la.com/en/hotels/jen/beijing/centraldistrict',
        price: 160
      },
      
      {
        hotel_img: '/hotels premium/RENAISSANCE BEIJING CAPITAL HOTEL.jpg',
        name: 'RENAISSANCE BEIJING CAPITAL HOTEL',
        url: 'https://www.marriott.com/en-us/hotels/bjsbc-renaissance-beijing-capital-hotel/overview/',
        price: 131
      },
    
      {
        hotel_img: '/hotels premium/ANDAZ XinTianDi.jpg',
        name: 'ANDAZ XinTianDi',
        url: 'https://www.hyatt.com/andaz/shaaz-andaz-xintiandi-shanghai',
        price: 222
      },
      {
        hotel_img: '/hotels premium/Kerry Hotel Pudong.jpg',
        name: 'Kerry Hotel Pudong',
        url: 'https://www.shangri-la.com/en/shanghai/kerryhotelpudong/',
        price: 150
      },
      {
        hotel_img: '/hotels premium/The Portman Ritz-Carlton.jpg',
        name: 'The Portman Ritz-Carlton',
        url: 'https://www.ritzcarlton.com/en/hotels/sharz-the-portman-ritz-carlton-shanghai/overview/',
        price: 201
      },
      {
        hotel_img: '/hotels premium/The St. Regis Jingan.jpg',
        name: 'The St. Regis Jingan',
        url: 'https://www.marriott.com/en-us/hotels/shaxr-the-st-regis-shanghai-jingan/overview/',
        price: 228
      },
      {
        hotel_img: '/hotels premium/Grand Hyatt Shanghai.jpg',
        name: 'Grand Hyatt Shanghai',
        url: 'https://www.hyatt.com/en-US/hotel/china/grand-hyatt-shanghai/shagh',
        price: 208
      },
      {
        hotel_img: '/hotels premium/Renaissance Shanghai Yu Garden Hotel.jpg',
        name: 'Renaissance Shanghai Yu Garden Hotel',
        url: 'https://www.marriott.com/en-us/hotels/shasy-renaissance-shanghai-yu-garden-hotel/overview/',
        price: 140
      },
      {
        hotel_img: '/hotels premium/Jingan Shangri-La.jpg',
        name: 'Jingan Shangri-La',
        url: 'https://www.shangri-la.com/en/shanghai/jinganshangrila/',
        price: 233
      },
      {
        hotel_img: '/hotels premium/Radisson Blu Hotel Shanghai New World.jpg',
        name: 'Radisson Blu Hotel Shanghai New World',
        url: 'https://www.radissonhotels.com/en-us/hotels/radisson-blu-shanghai-new-world',
        price: 113
      },
      {
        hotel_img: '/hotels premium/Meliá Shanghai Parkside.jpg',
        name: 'Meliá Shanghai Parkside',
        url: 'https://www.melia.com/en/hotels/china/shanghai/melia-shanghai-parkside',
        price: 241
      },
      {
        hotel_img: '/hotels premium/Niccolo Chengdu.jpg',
        name: 'Niccolo Chengdu',
        url: 'https://www.niccolohotels.com/en/niccolo-chengdu',
        price: 179
      },
      {
        hotel_img: '/hotels premium/JW Marriott Hotel Chengdu.jpg',
        name: 'JW Marriott Hotel Chengdu',
        url: 'https://www.marriott.com/en-us/hotels/ctumj-jw-marriott-hotel-chengdu/overview/',
        price: 135
      },
      {
        hotel_img: '/hotels premium/Fairmont Chengdu.jpg',
        name: 'Fairmont Chengdu',
        url: 'https://www.fairmont.com/chengdu/',
        price: 123
      },
      {
        hotel_img: '/hotels premium/The Ritz-Carlton Chengdu.jpg',
        name: 'The Ritz-Carlton Chengdu',
        url: 'https://www.ritzcarlton.com/en/hotels/cturz-the-ritz-carlton-chengdu/overview/',
        price: 157
      },
      {
        hotel_img: '/hotels premium/InterContinental Century City Chengdu.jpg',
        name: 'InterContinental Century City Chengdu',
        url: 'https://www.ihg.com/intercontinental/hotels/us/en/chengdu/ctuha/hoteldetail',
        price: 113
      },
      {
        hotel_img: '/hotels premium/The St. Regis Chengdu.jpg',
        name: 'The St. Regis Chengdu',
        url: 'https://www.marriott.com/en-us/hotels/ctuxr-the-st-regis-chengdu/overview/',
        price: 138
      },
      {
        hotel_img: '/hotels premium/Canopy by Hilton Chengdu City Centre.jpg',
        name: 'Canopy by Hilton Chengdu City Centre',
        url: 'https://www.hilton.com/en/hotels/ctulcpy-canopy-chengdu-city-centre/',
        price: 116
      },
      {
        hotel_img: '/hotels premium/Grand Hyatt Chengdu.jpg',
        name: 'Grand Hyatt Chengdu',
        url: 'https://www.hyatt.com/ru-RU/hotel/china/grand-hyatt-chengdu/ctugh',
        price: 120
      },
      {
        hotel_img: '/hotels premium/Shangri-La Chengdu.jpg',
        name: 'Shangri-La Chengdu',
        url: 'https://www.shangri-la.com/chengdu/shangrila/',
        price: 139
      },
     
      
      {
        hotel_img: '/hotels premium/InterContinental Chengdu Global Center.jpg',
        name: 'InterContinental Chengdu Global Center',
        url: 'https://www.ihg.com/intercontinental/hotels/us/en/chengdu/ctuic/hoteldetail',
        price: 106
      },
      {
        hotel_img: '/hotels premium/Seaton International Hotel Chengdu.jpg',
        name: 'Seaton International Hotel Chengdu',
        url: 'http://hilton.atchengduhotels.com/en/',
        price: 133
      },
      {
        hotel_img: '/hotels premium/Le Méridien Emei Mountain Resort.jpg',
        name: 'Le Méridien Emei Mountain Resort',
        url: 'https://www.marriott.com/en-us/hotels/ctumd-le-meridien-emei-mountain-resort/overview/',
        price: 105
      },
      {
        hotel_img: '/hotels premium/Conrad Jiuzhaigou.jpg',
        name: 'Conrad Jiuzhaigou',
        url: 'https://www.hilton.com/en/hotels/jzhcici-conrad-jiuzhaigou/',
        price: 174
      },
      {
        hotel_img: '/hotels premium/Banyan Tree Jiuzhaigou.jpg',
        name: 'Banyan Tree Jiuzhaigou',
        url: 'https://www.banyantree.com/china/banyan-tree-jiuzhaigou',
        price: 143
      },
      {
        hotel_img: '/hotels premium/Hotel Indigo JIUZHAI.jpg',
        name: 'Hotel Indigo JIUZHAI',
        url: 'https://www.ihg.com/hotelindigo/hotels/ru/ru/jiuzhaigou/lnljh/hoteldetail',
        price: 131
      },
      {
        hotel_img: '/hotels premium/Hilton Jiuzhaigou Resort.jpg',
        name: 'Hilton Jiuzhaigou Resort',
        url: 'https://www.hilton.com/en/hotels/jzhjihi-hilton-jiuzhaigou-resort/',
        price: 111
      },
      {
        hotel_img: '/hotels premium/Delta Hotels by Marriott Jiuzhaigou.jpg',
        name: 'Delta Hotels by Marriott Jiuzhaigou',
        url: 'https://www.marriott.com/en-us/hotels/jzhde-delta-hotels-jiuzhaigou/overview/',
        price: 134
      },
      {
        hotel_img: '/hotels premium/Kempinski Hotel Hangzhou.jpg',
        name: 'Kempinski Hotel Hangzhou',
        url: 'https://www.kempinski.com/en/hotel-hangzhou',
        price: 181
      },
      
      {
        hotel_img: '/hotels premium/The Azure Qiantang.jpg',
        name: 'The Azure Qiantang',
        url: 'https://www.myclubmarriott.com/hotel/hoteldetail/en/the-azure-qiantang-a-luxury-collection-hotel-hangzhou',
        price: 160
      },
      {
        hotel_img: '/hotels premium/Hangzhou Marriott Hotel Qianjiang.jpg',
        name: 'Hangzhou Marriott Hotel Qianjiang',
        url: 'https://www.marriott.com/en-us/hotels/hghqi-hangzhou-marriott-hotel-qianjiang/overview/',
        price: 132
      },
      {
        hotel_img: '/hotels premium/Midtown Shangri-La, Hangzhou.jpg',
        name: 'Midtown Shangri-La, Hangzhou',
        url: 'https://www.shangri-la.com/en/hangzhou/midtownshangrila/',
        price: 150
      },
      {
        hotel_img: '/hotels premium/Grand Hyatt Hangzhou.jpg',
        name: 'Grand Hyatt Hangzhou',
        url: 'https://www.hyatt.com/en-US/hotel/china/grand-hyatt-hangzhou/hangz',
        price: 194
      },
      {
        hotel_img: '/hotels premium/Millennium Resort Hangzhou.jpg',
        name: 'Millennium Resort Hangzhou',
        url: 'https://www.millenniumhotels.com/en/hangzhou/millennium-resort-hangzhou/',
        price: 126
      },
      {
        hotel_img: '/hotels premium/Sheraton Grand Hangzhou Wetland Park.jpg',
        name: 'Sheraton Grand Hangzhou Wetland Park',
        url: 'https://www.marriott.com/en-us/hotels/hghhs-sheraton-grand-hangzhou-wetland-park-resort/overview/',
        price: 122
      },
      {
        hotel_img: '/hotels premium/JW Marriott Hotel Hangzhou.jpg',
        name: 'JW Marriott Hotel Hangzhou',
        url: 'https://www.marriott.com/en-us/hotels/hghjw-jw-marriott-hotel-hangzhou/overview/',
        price: 153
      },
      {
        hotel_img: '/hotels premium/Le Meridien Hangzhou, Binjiang.jpg',
        name: 'Le Meridien Hangzhou, Binjiang',
        url: 'https://www.marriott.com/en-us/hotels/hghmd-le-meridien-hangzhou-binjiang/overview/',
        price: 131
      },
      {
        hotel_img: '/hotels premium/InterContinental Hangzhou, an IHG Hotel.jpg',
        name: 'InterContinental Hangzhou, an IHG Hotel',
        url: 'https://www.ihg.com/intercontinental/hotels/us/en/hangzhou/hghha/hoteldetail',
        price: 143
      },
      {
        hotel_img: '/hotels premium/Sheraton Grand Hangzhou Binjiang Hotel.jpg',
        name: 'Sheraton Grand Hangzhou Binjiang Hotel',
        url: 'https://www.marriott.com/en-us/hotels/hghsi-sheraton-grand-hangzhou-binjiang-hotel/overview/',
        price: 112
      },
     
      {
        hotel_img: '/hotels premium/Sofitel Hangzhou Westlake.jpg',
        name: 'Sofitel Hangzhou Westlake',
        url: 'https://all.accor.com/hotel/5554/index.en.shtml',
        price: 163
      },
      {
        hotel_img: '/hotels premium/Atlantis Sanya.jpg',
        name: 'Atlantis Sanya ',
        url: 'https://www.atlantissanya.com/',
        price: 232
      },
      {
        hotel_img: '/hotels premium/1 Hotel Haitang Bay, Sanya.jpg',
        name: '1 Hotel Haitang Bay, Sanya',
        url: 'https://www.1hotels.com/haitang-bay',
        price: 135
      },
      {
        hotel_img: '/hotels premium/Banyan Tree Sanya.jpg',
        name: 'Banyan Tree Sanya',
        url: 'https://www.banyantree.com/china/sanya',
        price: 267
      },
      {
        hotel_img: '/hotels premium/Mandarin Oriental Sanya.jpg',
        name: 'Mandarin Oriental Sanya',
        url: 'https://www.mandarinoriental.com/en/sanya/dadonghai',
        price: 248
      },
      {
        hotel_img: '/hotels premium/The St. Regis Sanya Yalong Bay Resort.jpg',
        name: 'The St. Regis Sanya Yalong Bay Resort',
        url: 'https://www.marriott.com/en-us/hotels/syxxr-the-st-regis-sanya-yalong-bay-resort/overview/',
        price: 213
      },
      {
        hotel_img: '/hotels premium/The Ritz-Carlton Sanya, Yalong Bay.jpg',
        name: 'The Ritz-Carlton Sanya, Yalong Bay',
        url: 'https://www.ritzcarlton.com/en/hotels/syxrz-the-ritz-carlton-sanya-yalong-bay/overview/',
        price: 228
      },
      {
        hotel_img: '/hotels premium/Haikou Marriott Hotel.jpg',
        name: 'Haikou Marriott Hotel',
        url: 'https://www.marriott.com/en-us/hotels/hakmc-haikou-marriott-hotel/overview/',
        price: 113
      },
      {
        hotel_img: '/hotels premium/Pullman Haikou.jpg',
        name: 'Pullman Haikou',
        url: 'https://all.accor.com/hotel/B9I2/index.en.shtml',
        price: 112
      },
      {
        hotel_img: '/hotels premium/The Ritz-Carlton, Haikou.jpg',
        name: 'The Ritz-Carlton, Haikou',
        url: 'https://www.ritzcarlton.com/en/hotels/hakrz-the-ritz-carlton-haikou/overview/',
        price: 172
      },
      {
        hotel_img: '/hotels premium/InterContinental Haikou Seaview.jpg',
        name: 'InterContinental Haikou Seaview',
        url: 'https://www.intercontinental.com/hotels/us/en/haikou/hakul/hoteldetail',
        price: 108
      },
      {
        hotel_img: '/hotels premium/Niccolo Suzhou.jpg',
        name: 'Niccolo Suzhou',
        url: 'https://www.niccolohotels.com/en/niccolo-suzhou',
        price: 201
      },
      {
        hotel_img: '/hotels premium/Tonino Lamborghini Hotel Suzhou.jpg',
        name: 'Tonino Lamborghini Hotel Suzhou',
        url: 'https://tlhotelsgroup.com/en/suzhou/',
        price: 157
      },
      {
        hotel_img: '/hotels premium/Park Hyatt Suzhou.jpg',
        name: 'Park Hyatt Suzhou',
        url: 'https://www.hyatt.com/en-US/hotel/china/park-hyatt-suzhou/suzph',
        price: 180
      },
      {
        hotel_img: '/hotels premium/Kempinski Hotel Suzhou.jpg',
        name: 'Kempinski Hotel Suzhou',
        url: 'https://www.kempinski.com/en/hotel-suzhou',
        price: 101
      },
      {
        hotel_img: '/hotels premium/InterContinental Suzhou Hotel.jpg',
        name: 'InterContinental Suzhou Hotel',
        url: 'https://www.intercontinental.com/hotels/us/en/suzhou/suzha/hoteldetail',
        price: 140
      }
   
    ],
  },
  {
    id: 2,
    cover_name: "Сети отелей",
    cover_image: "/Hotel-Branding-Hospitality-Luxury.jpeg",
    cover_description: "Cover description",
    hotels: [
      {
        hotel_img: "/hotel-logos/accor.png",
        name: "Accor Hotel Group  ",
        url: "https://all.accor.com/ru/country/%D0%BE%D1%82%D0%B5%D0%BB%D0%B8-%D0%BA%D0%B8%D1%82%D0%B0%D0%B9-pcn.shtml",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/aman.png",
        name: "Aman Hotels ",
        url: "https://www.aman.com/destinations/country/china",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/ascott.png",
        name: "Ascott Residence",
        url: "https://www.ascottchina.com/en/serviceList.html",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/atlantis.png",
        name: "Atlantis Resorts",
        url: "https://www.atlantissanya.com/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/banyantree.png",
        name: "Banyan Tree Hotel Group ",
        url: "https://www.banyantree.com/china",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/dusit.png",
        name: "Dusit International ",
        url: "https://www.dusit.com/find-a-hotel/china/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/fourseasons.png",
        name: "Four Seasons Hotels and Resorts ",
        url: "https://www.fourseasons.com/landing-pages/corporate/four-seasons-hotels-in-china/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/hilton.png",
        name: "Hilton Worldwide ",
        url: "https://www.hilton.com/en/locations/china/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/hyatt.png",
        name: "Hyatt Hotels ",
        url: "https://www.hyatt.com/en-US/promo/china-hotels",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/IHG.png",
        name: "IHG Hotels & Resorts",
        url: "https://www.ihg.com/mainland-china",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/jumeirah.png",
        name: "Jumeirah",
        url: "https://www.jumeirah.com/en",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/kempinski.png",
        name: "Kempinski ",
        url: "https://www.kempinski.com/en/destinations/asia/china",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/langham.png",
        name: "Langham Hospitality Group",
        url: "https://www.langhamhotels.com/en/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/jwmariott.png",
        name: "Marriott International",
        url: "http://www.marriottcn.cn/en",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/millennium.png",
        name: "Millennium & Copthorne Hotels",
        url: "https://www.millenniumhotels.com/en/destinations/asia/china/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/MGM.png",
        name: "MGM Resorts",
        url: "https://www.mgmresorts.com/en/destinations.html",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/anantara.png",
        name: "Anantara Hotels, Resorts & Spas",
        url: "http://surl.li/qvypw",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/okura.png",
        name: "Okura Nikko Hotel",
        url: "https://www.okura-nikko.com/china/",
        price: "",
      },
      
      {
        hotel_img: "/hotel-logos/radisson.png",
        name: "Radisson Hotel Group",
        url: "https://www.radissonhotels.com/en-us/destination/china",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/universal.png",
        name: "Universal Studios Hotels",
        url: "https://www.universalbeijingresort.com/en/hotel/univeral-studios-grand-hotel",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/wyndham.jpeg",
        name: "Wyndham Hotels and Resorts",
        url: "http://www.wyndhamhotel.cn/en",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/atour.png",
        name: "Atour Lifestyle Holdings Limited",
        url: "http://www.hotelatour.cn/en",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/peninsula.png",
        name: "The Peninsula Hotels",
        url: "https://www.peninsula.com/en/default",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/langham.png",
        name: "Langham Hospitality Group",
        url: "https://www.langhamhotels.com/en/hotels/destination-listing/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/mandarinoriental.png",
        name: "Mandarin Oriental Hotel Group ",
        url: "https://www.mandarinoriental.com/en/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/rosewood.png",
        name: "Rosewood Hotel Group",
        url: "https://www.rosewoodhotels.com/en/default",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/shangrila.png",
        name: "Shangri-La Hotels and Resorts ",
        url: "https://www.shangri-la.com/en/find-a-hotel/",
        price: "",
      },
      {
        hotel_img: "/hotel-logos/wanda.png",
        name: "Wanda Hotels & Resorts",
        url: "https://www.wandahotels.com/en/",
        price: "",
      },
   
    ],
  },

];
export default hotels;
